import React from "react";
import { Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function Placeholder({ title, description, soon }) {
  return (
    <div className="p-6 lg:p-10 max-w-4xl">
      <div className="glass-card rounded-3xl p-8 lg:p-12 shadow-sm">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-11 w-11 rounded-2xl brand-gradient flex items-center justify-center shadow-md shadow-indigo-500/25">
            <Sparkles className="h-5 w-5 text-white" />
          </div>
          <div>
            <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">
              {title}
            </h1>
            <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">{description}</p>
          </div>
          {soon && <Badge className="ml-auto brand-gradient text-white border-transparent">Coming soon</Badge>}
        </div>
        <div className="mt-6 rounded-2xl border border-dashed border-slate-200 dark:border-white/10 p-8 text-center text-slate-500">
          This module is part of the ISOQuest Management Portal roadmap. The foundation is ready — full features will be layered in without redesigning the app.
        </div>
      </div>
    </div>
  );
}
